import { call, put } from 'redux-saga/effects';
import api from '../../services/api';

import { Creators as StatesCreators } from '../ducks/states';

export function* getStates() {
  const response = yield call(api.get, 'v2/location/states');
  if (response.ok) {
    yield put(StatesCreators.getStatesSuccess(response.data));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/states.js